import 'css-chunksrc/client/common/listToggleArrow/styles.scss';export default {
  "listToggleArrow": "_listToggleArrow_fyp5b_1"
};